const escapeHtml = (value: string): string =>
    value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

export const decodeHtmlEntities = (value: string): string => {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = value;
    return textarea.value;
};

export const plainTextToQuillHtml = (text: string): string => {
    if (!text) return '';

    return text
        .split('\n')
        .map((line) => `<p>${line ? escapeHtml(line) : '<br>'}</p>`)
        .join('');
};

export const quillHtmlToPlainText = (html: string): string => {
    if (!html) return '';

    const container = document.createElement('div');
    container.innerHTML = html;

    const blocks = container.querySelectorAll(':scope > p, :scope > div');
    if (blocks.length === 0) {
        return container.textContent ?? '';
    }

    return Array.from(blocks)
        .map((block) => {
            const innerHTML = block.innerHTML;
            if (innerHTML === '<br>' || innerHTML === '') return '';

            const tmp = document.createElement('div');
            tmp.innerHTML = innerHTML.replace(/<br\s*\/?>/gi, '\n');
            return tmp.textContent ?? '';
        })
        .join('\n');
};
